import React from 'react';

interface BadgeProps {
  children: React.ReactNode;
  variant?: 'success' | 'warning' | 'danger' | 'info' | 'neutral';
  size?: 'sm' | 'md';
}

const Badge: React.FC<BadgeProps> = ({ children, variant = 'neutral', size = 'md' }) => {
  const colors: Record<string, { bg: string; text: string }> = {
    success: { bg: 'var(--color-success-light)', text: 'var(--color-success)' },
    warning: { bg: 'var(--color-warning-light)', text: 'var(--color-warning)' },
    danger: { bg: 'var(--color-danger-light)', text: 'var(--color-danger)' },
    info: { bg: 'var(--color-info-light)', text: 'var(--color-info)' },
    neutral: { bg: 'var(--color-surface-hover)', text: 'var(--color-text-secondary)' },
  };

  const c = colors[variant];

  return (
    <span
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        padding: size === 'sm' ? '0.125rem 0.5rem' : '0.25rem 0.75rem',
        fontSize: size === 'sm' ? 'var(--font-size-xs)' : 'var(--font-size-sm)',
        fontWeight: 500,
        borderRadius: 'var(--radius-full)',
        background: c.bg,
        color: c.text,
        lineHeight: 1.4,
        whiteSpace: 'nowrap',
      }}
    >
      {children}
    </span>
  );
};

export default Badge;
